define('lq/events/actions/deleteCommand',['lq/events/actions/eventAction'],
    function (EventAction) {
	    'use strict';

	    function DeleteCommand(eventData, eventArg) {
	        EventAction.call(this, eventData, eventArg);
	        return this;
	    }

        EventAction.extend(DeleteCommand, EventAction);

        DeleteCommand.typeName = 'DeleteCommand';

	    DeleteCommand.prototype.getBatchType = function () {
            return EventAction.COMMAND_BATCH;
        };

	    DeleteCommand.prototype.createEventActionRequest = function () {
            var self = this;
	        
            return {
                eventActionType: "Delete",
                ObjectName: self.eventData.command
            };
        };

        return DeleteCommand;
    }
);
